'use strict';

/**
 * Объект закладки карточки.
 *
 * @class WebAccess.components.CardTab
 * @extends BaseObject
 * @property {string} _containerID ИД элемента страницы, в который будет помещен сгенерированный HTML-элемент закладки карточки.
 * @property {object} _model Модель закладки карточки.
 * @property {object} [_childComponents] Массив объектов закладки карточки, которыми можно управлять через клиентский API веб-доступа.
 * @property {boolean} _firstRender
 * @since 5.6.0
 */

(function (global) {
  var CardTab = BaseObject.extend({
    _containerId: '',
    _model: {},
    _childComponents: [],
    _firstRender: true,

    /**
     * Конструктор
     * @method WebAccess.components.CardTab#init
     * @param {string} containerId ИД элемента страницы, в который будет помещен сгенерированный HTML-элемент закладки карточки.
     * @param {object} model Модель закладки карточки.
     * @param {array} childComponents Массив объектов закладки карточки, которыми можно управлять через клиентский API веб-доступа.
     */
    init(containerId, model, childComponents) {
      this._containerId = containerId;
      this._model = model;
      this._extendModel();
      this.bindChildEvents(childComponents);

      $('html')
        .on(PAGE_EVENTS.TOGGLE_PERIOD, () => {
          this.updateHistoryTable({
            shouldResetScroll: true,
            forceRerender: true
          });
        })
        .on(PAGE_EVENTS.TAB_MODEL_CHANGE, () => {
          this._render();
        });

      this._render();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Подписывает на события дочерних компонент.
     *
     * @method WebAccess.components.CardTab#bindChildEvents
     * @param {object} childComponents Список дочерних компонент.
     * @return {WebAccess.components.CardTab} Текущая вкладка.
     */
    bindChildEvents(childComponents) {
      this._childComponents = childComponents;
      if (typeof this._childComponents === 'object') {
        this._childComponents.forEach((component) => {
          const componentEventChangeState = component[ 'class' ].EVENT.CHANGE_STATE || component.constructor.EVENT.CHANGE_STATE;
          component.bind(componentEventChangeState, () => {
            this._render();
          });
        });
      }
      return this;
    },

    /**
     * Отписывает от событий дочерних компонент.
     *
     * @method WebAccess.components.CardTab#unbindChildEvents
     */
    unbindChildEvents() {
      if (typeof this._childComponents === 'object') {
        this._childComponents.forEach((component) => {
          const componentEventChangeState = component[ 'class' ].EVENT.CHANGE_STATE || component.constructor.EVENT.CHANGE_STATE;
          component.unbind(componentEventChangeState);
        });
      }
      this._childComponents = [];
      return this;
    },

    /**
     * Обновляет закладку карточки.
     *
     * @method WebAccess.components.CardTab#updateModel
     * @param {object} model Модель закладки, которую нужно обновить.
     */
    updateModel(model) {
      // Если юзер ушёл с закладки "Карточка" - удаляем объект закладки "Карточка"
      // и анбайндим проверку на пользовательский ввод при попытке закрытия окна
      if (this._model.type !== model.type && this.mainTab) {
        this.mainTab.unbindEvents();
        this.mainTab = undefined;
      }
      this._model = model;
      this._extendModel();
      this._render(true);
    },

    /**
     * Сменить закладку (и обновить модель и КОМ)
     *
     * @method WebAccess.components.CardTab#_requestModelData
     * @private
     * @param {string} requestUrl Веб-сервис, который нужно вызвать для получения модели.
     * @param {object} requestParams Параметры запроса.
     */
    _requestModelData(requestUrl, requestParams) {
      WA.SRV.call(requestUrl, requestParams).done((res) => {
        this.updateModel(JSON.parse(res));
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обновление таблицы с историей работы с объектом на вкладке История.
     *
     * @method WebAccess.components.CardTab#updateHistoryTable
     * @param {object} params Параметры запроса к веб-сервису.
     */
    updateHistoryTable: function (params) {
      (function (me) {
        var historyModel = me._model.content.data;
        if (historyModel.isAllRowsDisplayed && !params.forceRerender) {
          me.sortHistoryTable(params, historyModel);
        } else {
          var requestParams = {
            id: WA.CR.ID,
            type: WA.CR.Type,
            referenceName: WA.CR.ReferenceCode,
            sortingColumnId: historyModel.sorting.columnId,
            sortingDirection: historyModel.sorting.direction,
            rowsCount: 100,
            skipRows: 0
          };
          if (params) {
            $.extend(requestParams, params);
            if (params.shouldResetScroll) {
              me._resetScroll();
            }
          }
          me._requestModelData('/api/CardForm.asmx/GetHistoryTab', requestParams);
        }
      })(this);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сортирует таблицу с историей работы с объектом на вкладке История.
     *
     * @method WebAccess.components.CardTab#sortHistoryTable
     * @param {object} params Параметры сортировки.
     * @param {object} historyModel Модель historyModel.
     */
    sortHistoryTable: function (params, historyModel) {
      var sorting = {
        columnId: params.sortingColumnId,
        direction: params.sortingDirection
      };
      var columnType = historyModel.tableColumns[ sorting.columnId ].columnType;
      historyModel.tableRows.sort(function (leader, follower) {
        var first = leader[ sorting.columnId ].join(' ');
        var second = follower[ sorting.columnId ].join(' ');
        switch (columnType) {
          case COLUMN_TYPE.DATE:
            const transformDatetime = (datetime) => {
              datetime = datetime.split(' ');

              // Получить дату
              let dateParts;
              let hoursAndMinutes;
              if (datetime[ 0 ].includes('.')) {
                // Русский формат
                dateParts = datetime[ 0 ].split('.').reverse();
                hoursAndMinutes = datetime[ 1 ].split(':');
              } else {
                // Американский формат
                dateParts = datetime[ 0 ].split('/');
                dateParts.unshift(dateParts.pop());

                // Преобразуем время
                hoursAndMinutes = datetime[ 1 ].split(':');
                if (datetime[ 2 ].toLowerCase() === 'pm') {
                  // += не будет работать, т.к. в массиве строки и это примется за конкатенацию
                  hoursAndMinutes[ 0 ] = +hoursAndMinutes[ 0 ] + 12;
                }
              }

              dateParts = [ ...dateParts, ...hoursAndMinutes ];
              return new Date(...dateParts);
            };
            first = transformDatetime(first);
            second = transformDatetime(second);
            break;
          case COLUMN_TYPE.INTEGER:
            first = parseInt(first);
            second = parseInt(second);
            break;
        }
        if (first > second || (columnType === COLUMN_TYPE.INTEGER && isNaN(second))) {
          return sorting.direction;
        } else if (first < second || (columnType === COLUMN_TYPE.INTEGER && isNaN(first))) {
          return -sorting.direction;
        } else {
          return 0;
        }
      });
      historyModel.sorting = sorting;
      this._render();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает модель закладки "Состояние" в карточках задач и заданий.
     *
     * @method WebAccess.components.CardTab#getFullCustomWorkState
     * @return {object} Модель закладки "Состояние".
     */
    getFullCustomWorkState: function () {
      this._requestModelData('/api/CardForm.asmx/GetFullCustomWorkStateTab', {
        id: WA.CR.ID,
        type: WA.CR.Type
      });
    },

    /**
     * Включает/выключает панель фильтрации (на вкладке "Состояние" карточки ЗЗУ).
     *
     * @method WebAccess.components.CardTab#toggleStateTreeFilterPanel
     * @since 5.6.1
     */
    toggleStateTreeFilterPanel() {
      // Получить состояние кнопки
      const toogleFilterPanelButton = WA.CR.toolBar.buttons.ToggleStateTreeFilterPanel;
      if (toogleFilterPanelButton) {
        const isFilterPanelVisible = !toogleFilterPanelButton.isSelected();
        WA.SRV.call('Session.asmx/SetUserProfileSettings', {
          ParamName: 'IsStateTreeFilterPanelVisible',
          ParamValue: isFilterPanelVisible,
        });

        if (isFilterPanelVisible) {
          toogleFilterPanelButton.select();
        } else {
          this._model.extended.applyFilter(STATETREE_FILTER.ALL);
          toogleFilterPanelButton.unSelect();
        }

        this._model.content.data.isFilterPanelVisible = isFilterPanelVisible;
        this._render();
      }
    },

    /**
     * Сбросить скролл (перемотать наверх) - при пересортировке и при сбросе/назначении фильтров.
     *
     * @method WebAccess.components.CardTab#_resetScroll
     * @private
     */
    _resetScroll() {
      $('#' + this._containerId).animate({
        scrollTop: 0
      }, 100);
    },

    /**
     * Расширить модель CardTab добавлением дополнительных функций и атрибутов.
     *
     * @method WebAccess.components.CardTab#_extendModel
     * @private
     */
    _extendModel() {
      if (this._model.toolbar) {
        this._model.toolbar.extended = {
          restore: () => {
            WA.CMP.wrappers.toolBar.ReactToolBar.toolbarRestore(
              this._model.toolbar,
              this._render.bind(this),
            );
          },
          collapseOneButton: () => {
            WA.CMP.wrappers.toolBar.ReactToolBar.toolbarCollapseOneButton(
              this._model.toolbar,
              this._render.bind(this),
            );
          },
        };
      }

      const isIe = WA.ENV.browser.name === 'IE';

      switch (this._model.type) {
        case TAB_TYPE.CUSTOM_WORK_STATE:
          const stateTab = new WebAccess.components.CardTabStateTab(this._model.content.data.jobStates);
          this._model.content.data.jobStates = stateTab.getStateTree();
          this._model.extended = stateTab.getExtendedProperties();
          this._model.extended.activeFilter = 0;
          this._model.extended.applyFilter = (filter) => {
            stateTab.applyFilter(this._model.extended.activeFilter = filter);
          };
          break;

        case TAB_TYPE.HISTORY:
          this._model.extended = {
            isIe: isIe,
            update: (requestParams) => {
              this.updateHistoryTable(requestParams);
            },
          };
          break;

        case TAB_TYPE.JOB_CARD:
        case TAB_TYPE.TASK_CARD:
          if (this.mainTab === undefined) {
            // Создаем экземпляр класса основной закладки карточки, содержащего всю специфичную для этой закладки логику.
            this.mainTab = new WebAccess.components.CardTabMainTab(this._model.content.data, this._model.type);
          } else {
            // Обновляем модель класса основной закладки карточки.
            this.mainTab.updateModel(this._model.content.data);
          }
          let processedContent = this.mainTab.getContent();
          this._model.content.data.main = processedContent.main;
          this._model.content.data.aside = processedContent.aside;
          this._model.extended = this.mainTab.getExtendedProperties();
          this._model.beforeRender = () => Core.tasks.unbindButtonsEnabling();
          this._model.afterRender = () => Core.tasks.bindButtonsEnabling();
          break;
      }
    },

    /**
     * Отрендерить компоненту CardTab с помощью react.
     * @private
     * @param {boolean} [isNewModel = false] TRUE если обновилась закладка, иначе - FALSE.
     */
    _render(isNewModel = false) {
      let reactRender = () => {
        if (isNewModel) {
          this.fire(PAGE_EVENTS.TAB_ON_BEFORE_RENDER_NEW_MODEL, this._model);
        }
        ReactDOM.render(
          React.createElement(Component.CardTab, this._model),
          document.getElementById(this._containerId),
          isNewModel ? () => $('html').trigger(PAGE_EVENTS.TAB_ON_AFTER_RENDER_NEW_MODEL) : null
        );
      };
      if (this._firstRender) {
        WA.ready(() => {
          if (this._firstRender) {
            reactRender();
            this._firstRender = false;
          }
        });
      } else {
        reactRender();
      }
    },

  });

  global.CardTab = CardTab;

})(window.WebAccess.components);
